import { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import searchQueries from '../../application/query';

function useSearch({ queryKey, resultKeys, entities = [], fields, extraFilters }) {
  const [queryParams, setParams] = useState({ limit: 20, offset: 0, value: '' });
  const [searchedValue, setSearchedValue] = useState(null);
  const [previousEntities, setPreviousEntities] = useState([]);
  const [previousOffset, setPreviousOffset] = useState(null);
  const buildSearchQuery = searchQueries[queryKey];

  const [getSearchResults, { loading, data = {} } = {}] = useLazyQuery(
    buildSearchQuery({ resultKeys }),
    { ssr: false }
  );

  const { search } = data;

  const defaultSearch = {
    results: [],
    jsonResults: null,
    total: 0
  };

  const { results, jsonResults, total } = search ?? defaultSearch;

  // todo: remove ssr: false once this bug is resolved https://github.com/apollographql/apollo-client/issues/9108
  // without ssr: false clients can hang in ssr.

  const handleQueryParams = newQueryParams => {
    setParams({ ...queryParams, ...newQueryParams });
  };

  useEffect(
    () => {
      const { limit, offset, value } = queryParams;
      const isNewValueSet = value && value !== searchedValue;
      const isNewOffsetSet = previousOffset !== null && offset !== previousOffset;
      const notSameLength = previousEntities.length !== entities.length;
      const parsedEntities = entities.length
        ? entities.map(entity => ({
            match: { docType: entity }
          }))
        : [];

      if (isNewValueSet || isNewOffsetSet || notSameLength) {
        getSearchResults({
          variables: {
            limit,
            offset,
            rawQuery: {
              query: {
                bool: {
                  must: [
                    {
                      query_string: {
                        query: value,
                        fields,
                        type: 'most_fields',
                        default_operator: 'AND',
                        extraFilters
                      }
                    },
                    {
                      bool: {
                        should: parsedEntities
                      }
                    }
                  ]
                }
              }
            }
          }
        });
        setSearchedValue(value);
        setPreviousOffset(offset);
        setPreviousEntities(entities);
      }
    },
    [
      queryParams,
      queryParams.limit,
      queryParams.value,
      queryParams.offset,
      searchedValue,
      previousOffset,
      getSearchResults,
      entities,
      fields,
      entities.length,
      previousEntities.length,
      extraFilters
    ]
  );

  return [
    { searchedValue: queryParams.value, loading, data: { results: results || jsonResults, total } },
    handleQueryParams
  ];
}

export default useSearch;
